<template>
  <a-card :bordered="false">
    <!-- ボタン操作区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('disp.btn.add') }}</a-button>

      <a-button @click="$refs.MenuAuthModal.handleOpen()" type="primary" icon="setting">权限</a-button>

      <a-button @click="batchDel" v-if="selectedRowKeys.length > 0" icon="close">{{
        $t('disp.btn.deleteBatch')
      }}</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info div-selected-info">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        {{ this.$t('disp.selected') }}
        <a class="a-selected-info">{{ selectedRowKeys.length }}</a>
        {{ this.$t('disp.item') }}
        <a @click="onClearSelected">{{ this.$t('disp.clear') }}</a>
      </div>

      <a-table
        :columns="columns"
        class="action"
        :bordered="false"
        :pagination="false"
        :dataSource="dataSource"
        :loading="loading"
        :expandedRowKeys="expandedRowKeys"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
          getCheckboxProps: (record) => ({
            props: { disabled: record.perms && record.perms.indexOf('flow:model') >= 0 },
          }),
        }"
        @expandedRowsChange="handleExpandedRowsChange"
      >
        <span slot="menuType" slot-scope="text, record">
          <span v-if="record.menuType == '2' && record.perms && record.perms.indexOf('flow:model') > -1">{{
            $t('disp.applyForm')
          }}</span>
          <span v-else-if="record.menuType == '2'">{{ $t('disp.menuType.element') }}</span>
          <span v-else-if="record.menuType == '1'">{{ $t('disp.menuType.page') }}</span>
          <span v-else>{{ $t('disp.menuType.root') }}</span>
        </span>

        <!-- 開始日 -->
        <span slot="startDate" slot-scope="text, record">
          <span v-if="record.startDate">{{ moment(record.startDate).format('YYYY-MM-DD') }}</span>
          <j-empty v-else></j-empty>
        </span>

        <!-- 終了日 -->
        <span slot="endDate" slot-scope="text, record">
          <span v-if="record.endDate">{{ moment(record.endDate).format('YYYY-MM-DD') }}</span>
          <j-empty v-else></j-empty>
        </span>

        <span slot="dataFilter" slot-scope="text, record" v-if="record.menuType != '2'">
          <!--<a-icon type="check" v-if="record.dataFilter" style="color: var(--color-green)" />-->
          <!--<i
            v-if="record.dataFilter"
            class="mdi mdi-database-lock-outline"
            style="font-size: 16px; color: var(--color-orange)"
          />-->
          <a-tag
            color="orange"
            v-if="record.dataFilter"
            style="font-size: 14px; width: min-content; display: inline-block; margin-right: 3px"
            >过滤</a-tag
          >
          <a-tag
            color="blue"
            v-if="!record.keepAlive"
            style="font-size: 14px; width: min-content; display: inline-block; margin-right: 3px"
            >刷新</a-tag
          >
          <a-tag
            color="green"
            v-if="record.alwaysShow"
            style="font-size: 14px; width: min-content; display: inline-block; margin-right: 3px"
            >常显</a-tag
          >
        </span>

        <span slot="action" slot-scope="text, record">
          <div v-if="record.perms == null || (record.perms && record.perms.indexOf('flow:model') < 0)">
            <a @click="handleEdit(record)">{{ $t('disp.btn.edit') }}</a>

            <a-divider type="vertical" />
            <a-dropdown>
              <a class="ant-dropdown-link">{{ $t('disp.btn.more') }}<a-icon type="down" /></a>
              <a-menu slot="overlay">
                <!-- <a-menu-item>
                  <a href="javascript:;" @click="handleDetail(record)">详情</a>
                </a-menu-item>-->

                <!-- サブメニュー追加 -->
                <a-menu-item v-if="record.menuType == 0 || record.menuType == 1">
                  <a href="javascript:;" @click="handleAddPage(record)">{{ $t('disp.btn.addPage') }}</a>
                </a-menu-item>

                <!-- エレメント追加 -->
                <a-menu-item v-if="record.menuType == 0 || record.menuType == 1">
                  <a href="javascript:;" @click="handleAddElement(record)">{{ $t('disp.btn.addElement') }}</a>
                </a-menu-item>

                <!-- 削除 -->
                <a-menu-item>
                  <a-popconfirm :title="$t('msg.confirm.delete')" @confirm="() => handleDelete(record.id)">
                    <a>{{ $t('disp.btn.delete') }}</a>
                  </a-popconfirm>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
          <!-- 申請フォーム編集 -->
          <a style="margin-left: -57px" v-else @click="handleRelateMenu(record)">{{ $t('disp.btn.edit') }}</a>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <MenuModal ref="modalForm" @ok="modalFormOk"></MenuModal>
    <RelateMenuModal ref="RelateMenuModal" @menuSaved="modalFormOk"></RelateMenuModal>
    <MenuAuthModal ref="MenuAuthModal"></MenuAuthModal>
  </a-card>
</template>

<script>
import { getPermissionList } from '@/api/api'
import { tableMixin } from '@/mixins/tableMixin'
import MenuModal from './modules/MenuModal'
import RelateMenuModal from '../k0011/modules/RelateMenuModal'
import MenuAuthModal from './MenuAuthModal'

export default {
  name: 'MenuManage',
  mixins: [tableMixin],
  components: {
    MenuModal,
    RelateMenuModal,
    MenuAuthModal,
  },
  data() {
    return {
      description: 'メニュー管理',
      // テーブルタイトル
      columns: [
        {
          title: this.$t('disp.menuName'),
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: this.$t('disp.menuType'),
          scopedSlots: { customRender: 'menuType' },
        },
        // {
        //   title: 'icon',
        //   dataIndex: 'icon',
        //   key: 'icon'
        // },
        {
          title: 'URL',
          dataIndex: 'url',
          key: 'url',
        },
        {
          title: this.$t('disp.component'),
          dataIndex: 'component',
          key: 'component',
        },
        {
          title: '使用' + this.$t('disp.flow.process.startDate'),
          align: 'left',
          scopedSlots: { customRender: 'startDate' },
        },
        {
          title: '使用' + this.$t('disp.flow.process.endDate'),
          align: 'left',
          scopedSlots: { customRender: 'endDate' },
        },
        {
          title: this.$t('disp.sort'),
          dataIndex: 'sortNo',
          key: 'sortNo',
        },
        {
          title: '附加属性',
          scopedSlots: { customRender: 'dataFilter' },
          //align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
      ],
      loading: false,
      // 現在表示された行のキー
      expandedRowKeys: [],
      url: {
        list: '/blaze-sys/k00/k0005/MenuManage/list',
        delete: '/blaze-sys/k00/k0005/MenuManage/delete',
        deleteBatch: '/blaze-sys/k00/k0005/MenuManage/deleteBatch',
      },
    }
  },
  methods: {
    searchQuery() {
      this.dataSource = []
      this.selectedRowKeys = []
      this.selectionRows = []
      getPermissionList().then((res) => {
        if (res.success) {
          this.dataSource = res.result
        }
      })
    },
    handleAdd: function () {
      this.$refs.modalForm.title = this.$t('disp.btn.add')
      this.$refs.modalForm.disableSubmit = false
      this.$refs.modalForm.localMenuType = 0
      this.$refs.modalForm.edit({ status: '1', permsType: '1', route: true, keepAlive: true, alwaysShow: false })
    },
    handleAddPage(record) {
      this.$refs.modalForm.title = this.$t('disp.btn.add')
      this.$refs.modalForm.disableSubmit = false
      this.$refs.modalForm.localMenuType = 1
      this.$refs.modalForm.edit({
        status: '1',
        permsType: '1',
        route: true,
        keepAlive: true,
        alwaysShow: false,
        parentId: record.id,
      })
    },
    handleAddElement(record) {
      this.$refs.modalForm.title = this.$t('disp.btn.add')
      this.$refs.modalForm.disableSubmit = false
      this.$refs.modalForm.localMenuType = 2
      this.$refs.modalForm.edit({ status: '1', permsType: '1', route: true, parentId: record.id })
    },
    handleExpandedRowsChange(expandedRows) {
      this.expandedRowKeys = expandedRows
    },
    handleRelateMenu(record) {
      this.$refs.RelateMenuModal.title = this.$t('disp.btn.edit')
      this.$refs.RelateMenuModal.name = record.name
      this.$refs.RelateMenuModal.perms = record.perms
      this.$refs.RelateMenuModal.alwaysShow = record.alwaysShow
      this.$refs.RelateMenuModal.edit(record)
    },
  },
}
</script>
<style scoped>
* {
  letter-spacing: 1px;
}

.div-disable {
  font-size: 12px;
  color: #bdbdbd;
  margin: -8px 0;
}
</style>
